import { Checkbox, Typography } from '@material-ui/core';
import * as React from 'react';
import VersionStore from 'src/new/versions/VersionStore';
import SelectedVersions, { SelectedState } from 'src/versions/SelectedVersions';
import VersionList from './VersionList';
import './VersionView.css';

interface Props {
    versions: VersionStore;
    selectedVersions: SelectedVersions;
    onSelectedVersionsChange: (selectedVersions: SelectedVersions) => void;
}

export default class VersionView extends React.Component<Props> {

    private isShiftKeyDown = false;

    constructor(props: Props) {
        super(props);
        this.handleTickBoxKeyDownUp = this.handleTickBoxKeyDownUp.bind(this);
        this.handleTickBoxChange = this.handleTickBoxChange.bind(this);
    }

    public render() {
        const selectedState = this.props.selectedVersions.getSelectedState();
        return (
            <nav>
                <div className="VersionView_Header">
                    <Typography
                        className="VersionView_HeaderText"
                        variant="h6">
                        Versions
                    </Typography>
                    <Checkbox
                        className="VersionView_HeaderTickBox"
                        checked={selectedState === SelectedState.ALL}
                        indeterminate={selectedState === SelectedState.SOME}
                        onKeyDown={this.handleTickBoxKeyDownUp}
                        onKeyUp={this.handleTickBoxKeyDownUp}
                        onChange={this.handleTickBoxChange} />
                </div>
                <div className="VersionView_List">
                    <VersionList
                        versions={this.props.versions}
                        selectedVersions={this.props.selectedVersions}
                        onSelectedVersionsChange={this.props.onSelectedVersionsChange} />
                </div>
            </nav>
        );
    }

    private handleTickBoxKeyDownUp(event: React.KeyboardEvent<HTMLElement>): void {
        this.isShiftKeyDown = event.shiftKey;
    }

    private handleTickBoxChange(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) {
        const indeterminate = event.target.dataset.indeterminate === 'true';
        const selectAll = indeterminate && this.isShiftKeyDown ? !checked : checked;
        this.props.onSelectedVersionsChange(this.props.selectedVersions.setAll(selectAll));
    }
}
